import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";export default (function (
datesNumber)


{var productsAvailableYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2099;var retroActiveDaysAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var retroDaysInMillis = retroActiveDaysAmount * 24 * 60 * 60 * 1000;
  var date = new Date(Date.now() - retroDaysInMillis);
  date.setDate(1); // IF YOU DON'T DO THIS YOU'LL NEVER GET FEBRUARY AMONG THE DATES!!! (Will fall over to the 3d of March)
  var currentMonth = date.getMonth();
  var effectiveDates = [];
  for (var i = 0; i < datesNumber; i += 1) {
    date.setMonth(currentMonth + 1); // Effective dates should start from the next month
    var month = date.getMonth() + 1; // In js months starts from the index 0;
    var year = date.getFullYear();
    if (productsAvailableYear >= year) {var _context;
      effectiveDates.push(_concatInstanceProperty(_context = "".concat(date.getFullYear(), "-")).call(_context, month < 10 ? "0".concat(month) : month, "-01"));
    }
    currentMonth += 1;
    if (currentMonth === 12) {
      currentMonth = 0;
    }
  }
  return effectiveDates;
});
//# sourceMappingURL=getEffectiveDates.js.map